import { Component, OnInit, Inject } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { NotesService } from '../../../services/notes.service';
import { NoteBuilderCreateComponent } from './note-builder-create/note-builder-create.component';
import { MessagingService } from '../../../services/messaging.service';
import {PredefinedNoteSetDataModel} from '../../../models/notes/predefined-note-set-data.model';
import {PredefinedNoteDataModel} from '../../../models/notes/predefined-note-data.model';

@Component({
  selector: 'app-note-builder',
  templateUrl: './note-builder.component.html',
  styleUrls: ['./note-builder.component.css']
})
export class NoteBuilderComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<NoteBuilderComponent>,
    public dialog: MatDialog,
    private notesService: NotesService,
    private messagingService: MessagingService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  note: string = ''; 
  contextPositionX = 0;
  contextPositionY = 0;
  dragContainerIndex = 0;
  isSaving: boolean = false;
  isLoading: boolean = false;
  hasDragged: boolean = false;
  showContext: boolean = false;
  draggingEnabled: boolean = false;
  allowEditOptions: boolean = true;
  clickedEmptySpace: boolean = false;
  dataNoteSet: PredefinedNoteSetDataModel;
  predefinedNoteOrganizer: any[] = [];
  activeContextNote: PredefinedNoteDataModel;
  disableContextActions: boolean = false;
  saveAllPredefinedNotesSub: boolean = false;

  private separatorString: string = '________________________________________________';

  ngOnInit() {
    this.note = this.data.note;
    this.init();
  }

  init() {
    this.isLoading = true;
    this.fetchBuilderNotes()
      .then((result: PredefinedNoteSetDataModel) => {
        this.dataNoteSet = result;
        this.dataNoteSet.dataPredefinedNotes = this.dataNoteSet.dataPredefinedNotes.sort((a, b) => {
          return a.NoteOrder - b.NoteOrder;
        });
        this.organizePredefinedNotes();
        this.isLoading = false;
      }, err => {
        console.log('err', err);
        this.isLoading = false;
        this.messagingService.sendComponentMessage('notesDisplayWarning', {
          message: 'Whoops... something went wrong'
        });
      });
  }

  organizePredefinedNotes() {
    this.dataNoteSet.dataPredefinedNotes = this.dataNoteSet.dataPredefinedNotes.filter(note => {
      return !note.xauditDeleted;
    });

    this.dataNoteSet.dataPredefinedNotes = this.dataNoteSet.dataPredefinedNotes.sort((a, b) => {
      return a.NoteOrder - b.NoteOrder;
    });
    const top = this.dataNoteSet.dataPredefinedNotes.length;
    const arrayGroup = [
      [],
    ];

    if (top > 27) {
      const splitNum = Math.round((this.dataNoteSet.dataPredefinedNotes.length) / 5);
      let internalCounter = 0;
      let arrayIndex = 0;


      for (let i = 0; i < top; i++) {
        const currentNote = this.dataNoteSet.dataPredefinedNotes[i];
        if (internalCounter > splitNum) {
          internalCounter = 0;
          arrayIndex++;
          arrayGroup.push([]);
        }

        arrayGroup[arrayIndex].push(currentNote);
        internalCounter++;
      }

    } else {
      arrayGroup[0] = this.dataNoteSet.dataPredefinedNotes;
    }
    while (arrayGroup.length < 5) {
      arrayGroup.push([]);
    }
    this.predefinedNoteOrganizer = arrayGroup;
  }

  fetchBuilderNotes() {
    const promise = new Promise((resolve, reject) => {
      this.notesService.getNoteBuilderSet()
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  addToNote(predefinedNote: PredefinedNoteDataModel, prevNote: PredefinedNoteDataModel) {
    if (prevNote && prevNote.NoteDescription === this.separatorString) {
      return;
    }

    if (predefinedNote.isSeparator || predefinedNote.NoteDescription === this.separatorString) {
      return;
    }

    this.note += predefinedNote.NoteTemplate + ' ';
  }

  save() {
    this.dialogRef.close({
      note: this.note,
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }

  noteHasTemplate(predefinedNote: PredefinedNoteDataModel) {
    return this.note.indexOf(predefinedNote.NoteTemplate) > -1;
  }

  onRightClickEmptyEvent(event, predefinedNote: PredefinedNoteDataModel, dragContainerIndex) {
    this.dragContainerIndex = dragContainerIndex;
    this.contextPositionX = event.clientX;
    this.contextPositionY = event.clientY;
    this.allowEditOptions = false;
    this.clickedEmptySpace = true;
    this.activeContextNote = null;
    this.showContext = true;
  }

  onRightClickEvent(event, predefinedNote: PredefinedNoteDataModel) {
    this.contextPositionX = event.clientX;
    this.contextPositionY = event.clientY;
    this.allowEditOptions = true;
    this.clickedEmptySpace = false;
    this.activeContextNote = predefinedNote;
    this.showContext = true;
  }

  hideContextMenu() {
    this.showContext = false;
  }

  addNewPredefinedNoteUnder(isEdit: boolean) {
    this.showContext = false;
    this.openNoteBuilderCreateDialog(this.activeContextNote, isEdit);
  }

  getLastOrder(containerIndex) {
    let order = 1;
    if (this.predefinedNoteOrganizer.length && this.predefinedNoteOrganizer[containerIndex].length) {
      order = this.predefinedNoteOrganizer[containerIndex][this.predefinedNoteOrganizer[containerIndex].length - 1].NoteOrder + 1;
    } else if (containerIndex !== 0) {
      return this.getLastOrder(containerIndex - 1);
    }
    return order;
  }

  openNoteBuilderCreateDialog(noteContext: PredefinedNoteDataModel, isEdit: boolean): void {

    let emptyNoteOrder = -1;
    const data: any = {};
    if (isEdit) {
      data.predefinedNote = noteContext;
    } else if (this.clickedEmptySpace) {
      emptyNoteOrder = this.getLastOrder(this.dragContainerIndex);
    }

    const dialogRef = this.dialog.open(NoteBuilderCreateComponent, {
      width: '550px',
      height: '275px',
      data
    });
    dialogRef.afterClosed().subscribe(
      (result: PredefinedNoteDataModel) => {
        if (result) {

          const notesToSave: PredefinedNoteDataModel[] = [];

          if (isEdit) {

            this.dataNoteSet.dataPredefinedNotes.forEach(note => {
              if (note.PredefinedNoteId === result.PredefinedNoteId) {
                note.NoteTemplate = result.NoteTemplate;
                note.NoteDescription = result.NoteDescription;
                notesToSave.push(note);
              }
            });

            this.isSaving = true;
            this.saveAllPredefinedNotes(notesToSave)
              .then((results: PredefinedNoteDataModel[]) => {
                this.isSaving = false;
                this.messagingService.sendComponentMessage('notesDisplaySuccess', {
                  message: 'Changes have been saved'
                });
              }, err => {
                this.isSaving = false;
                console.log(err);
                this.messagingService.sendComponentMessage('notesDisplayWarning', {
                  message: 'Whoops... something went wrong'
                });
              });

          } else {

            let startOrder = -1;

            if (this.clickedEmptySpace) {
              startOrder = emptyNoteOrder;
            } else {
              startOrder = noteContext.NoteOrder + 1;
            }

            this.dataNoteSet.dataPredefinedNotes.forEach(note => {
              if (note.NoteOrder >= startOrder) {
                note.NoteOrder++;
              }
              notesToSave.push(note);
            });
            const newNote: PredefinedNoteDataModel = result;
            newNote.NoteOrder = startOrder;
            newNote.NoteSetId = this.dataNoteSet.NoteSetId;

            notesToSave.push(newNote);
            this.dataNoteSet.dataPredefinedNotes.push(newNote);
            this.organizePredefinedNotes();
            this.isSaving = true;
            this.disableContextActions = true;
            this.saveAllPredefinedNotes(notesToSave)
              .then((results: PredefinedNoteDataModel[]) => {
                this.isSaving = false;
                this.disableContextActions = false;
                this.allowEditOptions = true;
                this.clickedEmptySpace = false;
                this.dataNoteSet.dataPredefinedNotes = results;
                this.organizePredefinedNotes();
                this.messagingService.sendComponentMessage('notesDisplaySuccess', {
                  message: 'Changes have been saved'
                });
              }, err => {
                this.disableContextActions = false;
                this.allowEditOptions = true;
                this.clickedEmptySpace = false;
                this.isSaving = false;
                console.log(err);
                this.messagingService.sendComponentMessage('notesDisplayWarning', {
                  message: 'Whoops... something went wrong'
                });
              });
          }
        }
      },
      err => {
        console.log('err', err);
        this.messagingService.sendComponentMessage('notesDisplayWarning', {
          message: 'Whoops... something went wrong'
        });
      }
    );
  }

  removePredefinedNote(noteContext: PredefinedNoteDataModel) {
    noteContext.xauditDeleted = true;
    this.organizePredefinedNotes();
    this.showContext = false;
    this.isSaving = true;
    this.disableContextActions = true;
    this.saveAllPredefinedNotes([noteContext])
      .then((results: PredefinedNoteDataModel[]) => {
        this.isSaving = false;
        this.disableContextActions = false;
        this.organizePredefinedNotes();
        this.messagingService.sendComponentMessage('notesDisplaySuccess', {
          message: 'Changes have been saved'
        });
      }, err => {
        this.isSaving = false;
        this.disableContextActions = false;
        this.messagingService.sendComponentMessage('notesDisplayWarning', {
          message: 'Whoops... something went wrong'
        });
        console.log('err', err);
      });
  }

  saveAllPredefinedNotes(predefinedNotes: PredefinedNoteDataModel[]) {
    const promise = new Promise((resolve, reject) => {
      this.notesService.savePredefinedNotes(predefinedNotes)
        .subscribe(response => {
          this.saveAllPredefinedNotesSub = false;
          resolve(response);
        }, err => {
          this.saveAllPredefinedNotesSub = false;
          reject(err);
        });
    });
    return promise;
  }

  deleteContext() {
    this.removePredefinedNote(this.activeContextNote);
  }

  addSeperator(header: string) {
    this.showContext = false;
    const startOrder = this.activeContextNote.NoteOrder + 1;
    const notesToSave: PredefinedNoteDataModel[] = [];

    this.dataNoteSet.dataPredefinedNotes.forEach(note => {
      if (note.NoteOrder >= startOrder) {
        note.NoteOrder += 2;
      }
      notesToSave.push(note);
    });

    const separatorNewNote: PredefinedNoteDataModel = new PredefinedNoteDataModel();
    separatorNewNote.NoteDescription = this.separatorString;
    separatorNewNote.NoteTemplate = this.separatorString;
    separatorNewNote.NoteOrder = startOrder;
    separatorNewNote.NoteSetId = this.dataNoteSet.NoteSetId;

    const headerToCap = header.toLocaleUpperCase();
    const headerNewNote: PredefinedNoteDataModel = new PredefinedNoteDataModel();
    headerNewNote.NoteDescription = headerToCap;
    headerNewNote.NoteTemplate = headerToCap;
    headerNewNote.NoteOrder = separatorNewNote.NoteOrder + 1;
    headerNewNote.NoteSetId = this.dataNoteSet.NoteSetId;

    notesToSave.push(separatorNewNote);
    notesToSave.push(headerNewNote);
    this.dataNoteSet.dataPredefinedNotes.push(separatorNewNote);
    this.dataNoteSet.dataPredefinedNotes.push(headerNewNote);

    this.organizePredefinedNotes();

    this.isSaving = true;
    this.disableContextActions = true;
    this.saveAllPredefinedNotes(notesToSave)
      .then((results: PredefinedNoteDataModel[]) => {
        this.dataNoteSet.dataPredefinedNotes = results;
        this.organizePredefinedNotes();
        this.isSaving = false;
        this.disableContextActions = false;
        this.messagingService.sendComponentMessage('notesDisplaySuccess', {
          message: 'Changes have been saved'
        });
      }, err => {
        console.log(err);
        this.disableContextActions = false;
        this.isSaving = false;
        this.messagingService.sendComponentMessage('notesDisplayWarning', {
          message: 'Whoops... something went wrong'
        });
      });
  }

  toggleDraggingEnabled() {
    if (this.draggingEnabled) {
      this.disableContextActions = false;
      this.draggingEnabled = !this.draggingEnabled;
    } else {
      this.disableContextActions = true;
      this.draggingEnabled = !this.draggingEnabled;
    }
  }

  drop(event: CdkDragDrop<PredefinedNoteDataModel[]>) {
    this.hasDragged = true;
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  saveDragChanges() {
    this.hasDragged = false;
    this.isLoading = true;
    const newArr: PredefinedNoteDataModel[] = [];
    this.predefinedNoteOrganizer.forEach(o => {
      o.forEach((d: PredefinedNoteDataModel) => { newArr.push(d); });
    });

    let indexCount = 0;
    newArr.forEach(n => {
      indexCount++;
      n.NoteOrder = indexCount;
    });

    this.isSaving = true;
    this.saveAllPredefinedNotes(newArr)
      .then(result => {
        this.init();
        this.isSaving = false;
        this.messagingService.sendComponentMessage('notesDisplaySuccess', {
          message: 'Changes have been saved'
        });
      }, err => {
        this.isLoading = false;
        this.isSaving = false;
        console.log('err', err);
        this.messagingService.sendComponentMessage('notesDisplayWarning', {
          message: 'Whoops... something went wrong'
        });
      });
  }

  undoDragChanges() {
    this.organizePredefinedNotes();
    this.hasDragged = false;
  }

}
